import UnlitMaterial from 'nanogl-gltf/lib/extensions/KHR_materials_unlit/UnlitMaterial'
import { ColorSpace } from 'nanogl-pbr/ColorSpace'
import { Uniform } from 'nanogl-pbr/Input'

const origSeup = UnlitMaterial.prototype.setupMaterials
UnlitMaterial.prototype.setupMaterials = function () {
  origSeup.call(this)
  this._materialPass.baseColorFactor.colorspace = ColorSpace.SRGB
  const uniform = this._materialPass.baseColorFactor.param as Uniform
  if (uniform) {
    uniform.value[0] = Math.pow(uniform.value[0], 1 / 2.2)
    uniform.value[1] = Math.pow(uniform.value[1], 1 / 2.2)
    uniform.value[2] = Math.pow(uniform.value[2], 1 / 2.2)
  }
}

const origuniformSetup = Uniform.prototype.setup
Uniform.prototype.setup = function (prg) {
  prg[this.name]?.((this as unknown as { _value: unknown })._value)
  this._invalid = false
}
